import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { usePageMeta } from '../hooks/usePageMeta';
import './learn/learn.css';

// Page 404 : servie avec un vrai statut 404 par Vercel (build/404.html) et
// marquée noindex côté client, pour qu'aucune URL inconnue ne soit indexée
// comme un doublon de l'accueil.
const NotFound: React.FC = () => {
  const { i18n } = useTranslation();
  const en = i18n.language === 'en';
  const title = en ? 'Page not found — JogoLinga' : 'Page introuvable — JogoLinga';
  usePageMeta(title, en ? 'This page does not exist.' : "Cette page n'existe pas.", '/404', true);

  return (
    <main className="jg-learn">
      <h1>{en ? 'Page not found' : 'Page introuvable'}</h1>
      <p className="jg-learn__lead">
        {en
          ? 'The page you are looking for does not exist or has been moved.'
          : "La page que vous cherchez n'existe pas ou a été déplacée."}
      </p>
      <ul>
        <li><Link to="/">{en ? 'Home' : 'Accueil'}</Link></li>
        <li><Link to="/apprendre">{en ? 'Free lessons: vocabulary and grammar' : 'Leçons gratuites : vocabulaire et grammaire'}</Link></li>
        <li><Link to="/guide/wolof">{en ? 'Wolof guide' : 'Guide du wolof'}</Link></li>
      </ul>
    </main>
  );
};

export default NotFound;
